import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f0b6296"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parent" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "nav-content" }
const _hoisted_4 = { class: "nav-content" }

import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'FavListNav',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_BNavItem = _resolveComponent("BNavItem")!
  const _component_BNav = _resolveComponent("BNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BNav, { fill: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_BNavItem, {
            to: { name: 'FavList' },
            "exact-active-class": "active",
            class: "nav-item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(FeatherIcon, {
                  icon: "heart",
                  size: "13",
                  class: "favorite-icon"
                }),
                _createTextVNode("\n            事業所\n          ")
              ])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_BNavItem, {
            to: { name: 'WatchLaterOrders' },
            "exact-active-class": "active",
            class: "nav-item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(FeatherIcon, {
                  icon: "paperclip",
                  size: "13",
                  class: "watch-later-icon"
                }),
                _createTextVNode("\n            お仕事\n          ")
              ])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})